import React, { useRef } from 'react';
import Navbar from '../../components/Common/Navbar/Navbar';
import Footer from '../../components/Common/Footer/Footer';
import useSectionRefs from '../../hooks/useSectionRefs';
import AVDQuestionnaire from '../../components/AVDAssessment/AVDQuestionnaire';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import { Sparkles as SparklesComp } from '../../components/ui/sparkles-pricing';
import { TimelineContent } from '../../components/ui/timeline-content-pricing';
import './AVDAssessment.css';

const AVDAssessment: React.FC = () => {
  const sectionRefs = useSectionRefs();
  const avdRef = useRef<HTMLDivElement>(null);

  const revealVariants = {
    visible: (i: number) => ({
      y: 0,
      opacity: 1,
      filter: "blur(0px)",
      transition: {
        delay: i * 0.1,
        duration: 0.2,
      },
    }),
    hidden: {
      filter: "blur(10px)",
      y: -20,
      opacity: 0,
    },
  };

  return (
    <div className="tw-relative tw-bg-black tw-min-h-screen">
      {/* Background Effects */}
      <div className="tw-absolute tw-inset-0 tw-pointer-events-none">
        <div className="tw-absolute tw-top-0 tw-h-96 tw-w-full tw-overflow-hidden [mask-image:radial-gradient(50%_50%,white,transparent)]">
          <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-bg-[linear-gradient(to_right,#ffffff2c_1px,transparent_1px),linear-gradient(to_bottom,#3a3a3a01_1px,transparent_1px)] tw-bg-[size:70px_80px]"></div>
          <SparklesComp
            density={1800}
            speed={1}
            color="#FFFFFF"
            className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-full tw-w-full [mask-image:radial-gradient(50%_50%,white,transparent_85%)]"
          />
        </div>

        <div className="tw-absolute tw-left-0 tw-top-[-114px] tw-w-full tw-h-[100vh] tw-overflow-hidden">
          <div
            className="tw-absolute tw-left-[-568px] tw-right-[-568px] tw-top-0 tw-h-[2053px] tw-rounded-full"
            style={{
              border: "200px solid var(--gradient-color)",
              filter: "blur(92px)",
              WebkitFilter: "blur(92px)",
            }}
          ></div>
        </div>

        <div
          className="tw-absolute tw-top-0 tw-left-[10%] tw-right-[10%] tw-w-[80%] tw-h-full"
          style={{
            backgroundImage: `radial-gradient(circle at center, var(--gradient-color) 0%, transparent 70%)`,
            opacity: 0.6,
            mixBlendMode: "multiply",
          }}
        />

        <div
          className="tw-absolute tw-top-[60%] tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-w-[1400px] tw-h-[800px]"
          style={{
            background: `radial-gradient(ellipse at center, rgba(49, 49, 245, 0.6) 0%, rgba(49, 49, 245, 0.3) 40%, rgba(49, 49, 245, 0.1) 70%, transparent 100%)`,
            filter: "blur(70px)",
            borderRadius: "50%",
          }}
        />
      </div>

      {/* Navbar */}
      <div className="tw-relative tw-z-50">
        <Navbar
          sectionRefs={sectionRefs}
          openContactModal={() => {}}
          closeContactModal={() => {}}
        />
      </div>

      <section id="start" className="section dark tw-relative tw-z-10" ref={sectionRefs.start}>
        <div className="avd-wrapper" ref={avdRef}>
          <AVDQuestionnaire />
        </div>
      </section>

      <section id="newsletter" className="section dark tw-relative tw-z-10" ref={sectionRefs.newsletter}>
        <ContactLinkSection
          title="Modernisez votre espace de travail avec AVD"
          subtitle="Recevez des recommandations concrètes pour améliorer sécurité, agilité et expérience utilisateur."
        />
        <Footer />
      </section>
    </div>
  );
};

export default AVDAssessment;
